export const home = {
  'hero.eyebrow': 'CSSBuy Spreadsheet • Products • Guides • QC • Shipping',
  'hero.h1': 'CSSBuy Spreadsheet: Find Products, Links & Guides in One Place',
  'hero.subtitle': 'Explore the CSSBuy Spreadsheet, discover products and links, compare options and find practical information about QC, warehouse, shipping costs and international shopping.',
  'hero.cta.primary': 'Explore CSSBuy Spreadsheet',
  'hero.cta.secondary': 'View CSSBuy Guides',
  'hero.trust': 'Organized information • Practical guides • Clear comparisons • Updated content',

  'spreadsheet.h2': 'Your starting point for CSSBuy Spreadsheet',
  'spreadsheet.text': 'Finding products and understanding international shopping can be confusing. We organize information, links, guides and comparisons related to CSSBuy in one place to help you research better and make more informed decisions.',
  'spreadsheet.cta': 'Explore CSSBuy Spreadsheet',

  'what.h2': 'What is the CSSBuy Spreadsheet?',
  'what.text': 'The CSSBuy Spreadsheet is a practical way to organize and research products, links and information related to CSSBuy. You can compare categories, check available information and find guides on QC, storage and shipping before making a decision.',

  'how.h2': 'How to Use the CSSBuy Spreadsheet',
  'how.step1.title': 'Find a product',
  'how.step1.desc': 'Search for the desired category or product.',
  'how.step2.title': 'Check the information',
  'how.step2.desc': 'Check description, seller, price and availability.',
  'how.step3.title': 'Compare options',
  'how.step3.desc': 'Compare products using organized information.',
  'how.step4.title': 'Check QC',
  'how.step4.desc': 'Learn what to check in photos and inspections.',
  'how.step5.title': 'Analyze shipping',
  'how.step5.desc': 'Consider weight, volume, destination and method.',
  'how.step6.title': 'Make an informed decision',
  'how.step6.desc': 'Always confirm current information before buying.',

  'categories.h2': 'Popular Categories from CSSBuy Spreadsheet',
  'categories.cta': 'View all categories',

  'guides.h2': 'Most Popular CSSBuy Guides',
  'guides.cta': 'View all guides',

  'shipping.h2': 'CSSBuy Shipping Cost: Understand the Costs',
  'shipping.text': 'Shipping costs can vary depending on weight, volume, destination, shipping method and current conditions. Learn which factors can influence the price before finalizing an order.',
  'shipping.cta': 'View CSSBuy Shipping Cost',

  'qc.h2': 'CSSBuy QC: Know What to Check',
  'qc.checks': 'Photos, Size, Color, Stitches, Details, Possible defects, Quantity, Packaging',
  'qc.cta': 'Learn about QC',

  'review.h2': 'CSSBuy Review: What to Analyze',
  'review.table.factor': 'Factor',
  'review.table.check': 'What to check',
  'review.cta': 'Read CSSBuy Review',

  'safety.h2': 'Is CSSBuy Legit?',
  'safety.text': 'Before using any international service, check the domain, policies, payments, shipping conditions and current information. Do not rely solely on reviews or third-party offers.',
  'safety.cta': 'View Safety Guide',

  'faq.h2': 'Frequently Asked Questions about CSSBuy Spreadsheet',
  'faq.cta': 'View all FAQ',

  'final.h2': 'Ready to explore the CSSBuy Spreadsheet?',
  'final.text': 'Start your research, find useful resources and continue to our main website when you are ready.',
  'final.cta': 'Explore CSSBuy Spreadsheet',

  'nav.home': 'Home',
  'nav.guides': 'Guides',
  'nav.shoppingGuide': 'Shopping Guide',
  'nav.categories': 'Categories',
  'nav.review': 'Review',
  'nav.shipping': 'Shipping',
  'nav.qc': 'QC',
  'nav.safety': 'Safety',
  'nav.faq': 'FAQ',
  'nav.article': 'Article',
  'nav.lang': 'Language',

  'cta.main1': 'CSSBuy Spreadsheet',
  'cta.main2': 'Buy it now',
  'cta.view': 'View Category',
  'cta.explore': 'Explore',
  'cta.read': 'Read Article',

  'footer.about': 'About',
  'footer.policy': 'Editorial Policy',
  'footer.contact': 'Contact',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms',
  'footer.disclaimer': 'This website is an independent informational resource and is not affiliated with or endorsed by CSSBuy unless explicitly stated.',
  'footer.rights': 'All rights reserved.',

  'notFound.title': 'Page Not Found',
  'notFound.subtitle': 'The page you are looking for does not exist. Return to the homepage and continue exploring.',
  'notFound.back': 'Back to Home',

  'article.title': 'CSSBuy Spreadsheet Guide 2026 — How to Find Products and Buy with Confidence',
  'article.meta': 'Learn how to use the CSSBuy Spreadsheet to find products, verify links, understand shipping costs and make informed decisions in international shopping.',
  'article.author': 'CSSBuy Spreadsheet Team',
  'article.published': 'Published on August 30, 2026',
  'article.updated': 'Updated on August 30, 2026',
  'article.toc': 'Contents',
  'article.takeaways': 'Key Takeaways',
  'article.faq': 'FAQ',
  'article.related': 'Related Articles',
  'article.back': 'Back to Home',
  'article.notFound': 'Article not found.',

  'pillar.h2': 'CSSBuy Guides & Articles',
  'pillar.subtitle': 'Explore our detailed guides on CSSBuy Spreadsheet, covering review, shipping, QC, warehouse, coupons and comparisons.',
  'pillar.read': 'Read article',
};

export default home;